import { normalizeGroupedFields } from "./workQ"

/**
 * Measure cumulative `left` for sticky columns (one pass for the whole table).
 * Each `data-index` appears on every row; we use the first matching cell (same as the old per-row hook).
 *
 * Uses O(K) DOM reads (one `querySelector` per sticky column) instead of nested `querySelectorAll`
 * loops, which were O(K²) scans of the full document per layout.
 */
export function computeStickyColumnOffsets(filteredData) {
    const groups = normalizeGroupedFields(filteredData)
    if (!groups.length) {
        return null
    }

    const stickyItems = []
    groups.forEach((element, element_index) => {
        if (!element?.items) return
        element.items.forEach((item, item_index) => {
            if (item.isSticky) {
                stickyItems.push({
                    ...item,
                    index: `index_${element_index}_${item_index}`,
                })
            }
        })
    })

    if (stickyItems.length === 0) {
        return []
    }

    const widths = stickyItems.map((item) => {
        const el = document.querySelector(`[data-index="${item.index}"]`)
        return el?.getBoundingClientRect().width ?? 0
    })

    let cum = 0
    return stickyItems.map((item, i) => {
        const left = cum
        cum += widths[i] ?? 0
        return { ...item, left }
    })
}
